import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { categories } from '../../data/categories';
import { shopShortcuts } from '../../data/navigation';
import { products } from '../../data/products';
import { easeOut } from '../../utils/motion';
interface MegaMenuProps {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}
export function MegaMenu({
  onMouseEnter,
  onMouseLeave
}: MegaMenuProps) {
  return <motion.div initial={{
    opacity: 0,
    y: -6
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -6
  }} transition={{
    duration: 0.18,
    ease: easeOut
  }} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className="absolute inset-x-0 top-full hidden border-b border-line bg-paper shadow-[0_24px_48px_-24px_rgba(30,26,22,0.25)] lg:block" data-id="element-432" data-mp="x427nsszoul7">
      <div className="mx-auto grid max-w-[1440px] grid-cols-[220px_1fr] gap-10 px-8 py-10" data-id="element-433" data-mp="37u91rn5ykqks">
        <ul className="space-y-3" data-id="element-434" data-mp="32wqu003oghed">
          {shopShortcuts.map(s => <li key={s.label} data-id="element-435" data-mp="14hghsb78hmyf">
              <Link to={s.to} className="font-display text-2xl leading-tight transition-colors duration-150 hover:text-clay" data-id="element-436" data-mp="14eap6lzec2xy">
                {s.label}
              </Link>
            </li>)}
        </ul>
        <ul className="grid grid-cols-4 gap-6" data-id="element-437" data-mp="1j6cuwmo5dq5w">
          {categories.map(c => {
          const count = products.filter(p => p.category === c.id).length;
          return <li key={c.id} data-id="element-438" data-mp="1s56os5a3g2fr">
                <Link to={`/boutique?categorie=${c.id}`} className="group block" data-id="element-439" data-mp="1s4eqgmp43qls">
                  <div className="aspect-[4/3] overflow-hidden rounded-sm bg-shell" data-id="element-440" data-mp="1x6466fna4sg7">
                    <img src={c.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-441" data-mp="224fgerhhl4yy" />
                  </div>
                  <p className="mt-3 text-sm font-medium" data-id="element-442" data-mp="7rz9dogv9mt1">{c.name}</p>
                  <p className="mt-0.5 text-xs text-muted" data-id="element-443" data-mp="3vv2zl2jhmcx0">
                    {c.tagline} · {count} pièces
                  </p>
                </Link>
              </li>;
        })}
        </ul>
      </div>
    </motion.div>;
}